var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('div',[_c('img',{attrs:{"width":"100%","height":"auto","src":_vm.type === '0' ? require('@/assets/联系客服2.jpg') :  require('@/assets/联系客服.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }